/**
 * Deck templates ("recipes") + recipe categories API slice.
 * Leaf module (Perf 3.1.b/e Step 6). Pulls only the shared chokepoint from
 * ./client; never imports a sibling @/lib/api slice.
 *
 * Public deck templates power the SEO pages at /decks/recipes and
 * /decks/recipes/[slug]. Categories drive /decks/recipes/category/<slug>.
 */
import { fetchWithAuth, ApiError } from './client';

// Public deck templates ("recipes") — power /decks/recipes.
export const deckTemplatesApi = {
  list: async ({ category, limit = 100 } = {}) => {
    const params = new URLSearchParams();
    if (category) params.set('category', category);
    if (limit) params.set('limit', String(limit));
    const qs = params.toString();
    return fetchWithAuth(`/json/deck-templates${qs ? `?${qs}` : ''}`);
  },

  getBySlug: async (slug) => {
    return fetchWithAuth(`/json/deck-templates/${encodeURIComponent(slug)}`);
  },

  favoriteDeckTemplate: async (templateId) => {
    const data = await fetchWithAuth(`/json/user/me/favorite-deck-templates/${encodeURIComponent(templateId)}`, {
      method: 'POST',
    });
    if (data.error) throw new ApiError(data.message || 'Failed to favorite recipe', data.status || 400, data);
    return !data.error;
  },

  unfavoriteDeckTemplate: async (templateId) => {
    const data = await fetchWithAuth(`/json/user/me/favorite-deck-templates/${encodeURIComponent(templateId)}`, {
      method: 'DELETE',
    });
    if (data.error) throw new ApiError(data.message || 'Failed to unfavorite recipe', data.status || 400, data);
    return !data.error;
  },
};

// Deck recipe categories — SEO payloads for /decks/recipes/category/<slug> (when added).
export const deckTemplateCategoriesApi = {
  list: async () => fetchWithAuth('/json/deck-template-categories'),

  getBySlug: async (slug) => {
    return fetchWithAuth(`/json/deck-template-categories/${encodeURIComponent(slug)}`);
  },
};
